import * as React from 'react';
import axios from 'axios';

//CORE COMPONENTS
import { 
    ThemeProvider, 
    styled 
} from '../../../components-core/packages/components-core/dist/theme-provider/index';

//LAYOUT
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container';


class Youtube extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    render() {

        return (
            <Container 
                    padding={{ 
                        top: ContainerPadding.dynamic0250, 
                        bottom: ContainerPadding.dynamic0250 
                    }}
                    horizontalAlign={ContainerHorizontalAlignment.center}>


                    <iframe width="850" height="450" src="https://www.youtube.com/embed/MkFl45ABIY4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Container>
        )
    }

}
export default Youtube;
